import i18n from '../../helpers/i18n';

import ErrorIcon from '../../icons/ErrorIcon';

const ProjectDeleted = ({ lang }) => {
  return (
    <div className='main-banner-container'>
      <div className='main-banner'>
        <div className='main-banner__title-container'>
          <ErrorIcon />
          <div className='main-banner__title'>
            {i18n.get('acceptProject.errorProjectDeletedTitle', lang)}
          </div>
          <div className='main-banner__subtitle'>
            {i18n.get('acceptProject.errorProjectDeletedSubtitle', lang)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDeleted;
